Number.prototype.toMoney = function (decimals, thousands_sep, decimal_sep) {
    var n = this,
        c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
        d = decimal_sep || '.', //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)

        /*
        according to [https://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
        the fastest way to check for not defined parameter is to use typeof value === 'undefined' 
        rather than doing value === undefined.
        */
        t = (typeof thousands_sep === 'undefined') ? '&nbsp;' : thousands_sep,
        //if you don't want to use a thousands separator you can pass empty string as thousands_sep value

        sign = (n < 0) ? '-' : '',

        //extracting the absolute value of the integer part of the number and converting to string
        i = parseInt(n = Math.abs(n).toFixed(c)) + '',

        j = ((j = i.length) > 3) ? j % 3 : 0;
    return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
}

function AttachDatePicker() {
    var $this = $(this);

    var date = $this.val().substring(0, 10);
    var minDate = $this.data('min-date');
    var maxDate = $this.data('max-date');
    var linkedMin = $this.data('linked-min');
    var linkedMax = $this.data('linked-max');
    var dateOffset = parseInt($this.data('date-offset')) || 0;
    
    date = date ? moment(date) : undefined;
    minDate = minDate ? moment(minDate) : undefined;
    maxDate = maxDate ? moment(maxDate) : undefined;

    var opts = {
        format: 'YYYY-MM-DD',
        date: date,
        minDate: minDate,
        maxDate: maxDate,
        useCurrent: false
    };

    var picker = $this.not('[readonly]').datetimepicker(opts);
    
    if (linkedMin) {
        linkedMin = $(linkedMin);
        picker.on("dp.change", function (e) {

            var limitDiff = opts.maxDate.diff(e.date, 'days');
            console.log('limitDiff', limitDiff);
            limitDiff = limitDiff < 360 ? limitDiff : 360;
            console.log('limitDiff', limitDiff);

            var maxLimitDate = moment(e.date, "DD-MM-YYYY").add(limitDiff, 'days');

            var diff = e.date.diff(linkedMin.data("DateTimePicker").date(), 'days');
            //console.log('diff', diff);
            if (diff >= 0) {

                var offsetDate = moment(e.date, "DD-MM-YYYY").add(dateOffset, 'days');

                linkedMin.data("DateTimePicker").maxDate(maxLimitDate).date(offsetDate);
            } else {
                if (diff < -360) {

                    var date = moment(e.date, "DD-MM-YYYY").add(360, 'days');
                    linkedMin.data("DateTimePicker").maxDate(maxLimitDate).date(date);

                } else {
                    linkedMin.data("DateTimePicker").maxDate(maxLimitDate);
                }
            }
        });
    }

    if (linkedMax) {
        linkedMax = $(linkedMax);

        picker.on("dp.change", function (e) {
            console.log('linkedMax', moment(e.date, "DD-MM-YYYY"));
            var diff = linkedMax.data("DateTimePicker").date().diff(e.date, 'days');

            if (diff >= 0) {
                var offsetDate = moment(e.date, "DD-MM-YYYY").add(-dateOffset, 'days');

                linkedMax.data("DateTimePicker").date(offsetDate);
            }

        });
    }
}

function AttachDateRangePicker(callback) {
    var $this = $(this);

    console.log('AttachDateRangePicker', $this);

    var endData = $this.data('end');
    var maxData = $this.data('max-date');

    var format = $this.data('format') || 'YYYY-MM-DD';
    var start = moment($this.data('start'));
    var end = endData ? moment(endData) : undefined;
    var max = maxData ? moment(maxData) : undefined;
    callback = callback || $this.data('callback');

    var opts = {
        format: format,
        startDate: start,
        endDate: end,
        maxDate: max,
        locale: {
            format: format
        },
        //language: l || 'en',
        //widgetPositioning: {
        //    horizontal: 'auto',
        //    vertical: 'auto'
        //},
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')
            ]
        }
    };

    console.log('AttachDateRangePicker', opts);


    if ($this.is(":button")) {
        if (opts.startDate.format("YYYY-MM-DD") === opts.endDate.format("YYYY-MM-DD")) {
            $this.find("span").html(opts.startDate.format("YYYY-MM-DD"));
        } else {
            $this.find("span").html(opts.startDate.format("YYYY-MM-DD") + " / " + opts.endDate.format("YYYY-MM-DD"));
        }
    }


    return $this/*.not('[readonly]')*/.daterangepicker(opts, function (start, end, label) {

        //console.log(typeof callback);

        if (callback && typeof callback === 'string')
            window[callback](start, end, label);

        if (callback && typeof callback === 'function')
            callback(start, end, label);
    });
}

function Ul(url) {
    return U + l + '/' + url;
}

function ToCurrency(amount) {
    return parseInt(amount) / 100.0;
}

function FromCurrency(amount) {
    return parseInt(amount * 100.0);
}

function CurrencySymbol(code) {
    switch (code) {
        case 'GEL':
            return '₾';
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        default:
            return code;
    }
}

function DisplayToCurrency(code, amount) {

    return CurrencySymbol(code) + ' ' + ToCurrency(amount);
};

function DisplayToMoney(code, amount) {

    return CurrencySymbol(code) + ' ' + ToCurrency(amount).toMoney('.', ',');
};



Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
    //console.log('Handlebars.registerHelper.ifCond', arguments);
    switch (operator) {
    case '==':
        return (v1 == v2) ? options.fn(this) : options.inverse(this);
    case '!=':
        return (v1 != v2) ? options.fn(this) : options.inverse(this);
    case '===':
        return (v1 === v2) ? options.fn(this) : options.inverse(this);
    case '<':
        return (v1 < v2) ? options.fn(this) : options.inverse(this);
    case '<=':
        return (v1 <= v2) ? options.fn(this) : options.inverse(this);
    case '>':
        return (v1 > v2) ? options.fn(this) : options.inverse(this);
    case '>=':
        return (v1 >= v2) ? options.fn(this) : options.inverse(this);
    case '&&':
        return (v1 && v2) ? options.fn(this) : options.inverse(this);
    case '||':
        return (v1 || v2) ? options.fn(this) : options.inverse(this);
    default:
        return options.inverse(this);
    }
});

Handlebars.registerHelper('for', function (from, to, incr, block) {

    var accum = '';
    for (var i = from; i <= to; i += incr)
        accum += block.fn(i);
    return accum;
});

Handlebars.registerHelper('forReverse', function (from, to, decr, block) {

    var accum = '';
    for (var i = from; i >= to; i -= decr)
        accum += block.fn(i);
    return accum;
});

Handlebars.registerHelper('toCurrency', function (amount) {

    return H.ToCurrency(amount);
});